export class AuthUser {
    username: string;
    token: string;
}
